<template>
  <v-btn color="primary" class="flex-grow-1 btn-basic"
         v-bind="$attrs"
         depressed
         :loading="isLoading"
         :disabled="disabled"
         @click="$emit('click')">
    {{ str }}
  </v-btn>
</template>
<script>
export default {
  props: {
    str: String,
    isLoading: Boolean,
    disabled: Boolean
  }
}
</script>
